import type { Application } from '../../../lib/api'
import { SectionBody, SectionHeader } from './StageContextLayout'

export function EsignCompletedContext({ app }: { app?: Application | null }) {
  return (
    <>
      <SectionHeader color="#dcfce7">
        <h3 style={{ fontSize: '15px', fontWeight: 600, color: '#166534' }}>eSign Completed</h3>
      </SectionHeader>
      <SectionBody>
        <p style={{ fontSize: '14px', color: '#166534', marginBottom: '8px' }}>
          The MPA has been signed. The signed PDF is archived to S3.
        </p>
        {app?.boldsign_signed_pdf_s3_key && (
          <p style={{ fontSize: '13px', color: '#6b7280', fontFamily: 'monospace' }}>
            S3: {app.boldsign_signed_pdf_s3_key}
          </p>
        )}
        {app?.boldsign_completed_at && (
          <p style={{ fontSize: '13px', color: '#6b7280', marginTop: '4px' }}>
            Completed: {new Date(app.boldsign_completed_at).toLocaleString()}
          </p>
        )}
      </SectionBody>
    </>
  )
}
